export default (state = [], action) => {
    switch (action.type) {
        case 'SURFACES_FETCH_SUCCESS':
            return action.surfaces;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/surfaceReducers.js